// extracted by mini-css-extract-plugin
export default {"info":"TabSlasherTile_info__s+2ii","tabsCount":"TabSlasherTile_tabsCount__bYLyB","mainIconStyle":"TabSlasherTile_mainIconStyle__Ie-xX","label":"TabSlasherTile_label__clsiW"};